export default {
  navbar: {
    Home: "Inicio",
    Dashboard: "Panel",
    My: "Mi espacio",
    Support: "Soporte",
    Projects: "Proyectos",
    ProjectCount: "Cuenta",
    Admin: "Administrador",
    Library: "Biblioteca",
    ProjectList: "Lista de proyectos",
    Profile: "Perfil",
    SiteObservation: "Observación en sitio",
    GenerateReport: "Generar informes",
    BaselineConfig: "Configuración de línea base",
    MonthlyBaseline: "Línea base mensual",
    EquipmentSpecs: "Especificaciones del equipo",
    BaselinePreview: "Vista previa de la línea base",
    Analysis: "Análisis",
    Menu: "Menú",
    Objective: "Objetivo",

    RetrofitSolution: "Solución de retrofit",
    ExistingEqptSpecs: "Especificaciones del equipo existente",

    Baseline: "Línea base",
    Proposed: "Propuesto",
    SetupOperatingCondition: "Configurar condición operativa",
    DefineNewEquipment: "Definir nuevo equipo"
  },

  ctrl: {
    Login: "Iniciar sesión",
    Logout: "Cerrar sesión",
    Register: "Registrarse",
    ModifyPassword: "Cambiar contraseña",
    Language: "Idioma",
    UserGuide: "Guía del usuario",
    UserSetting: "Configuración de usuario",
    Delete: "Eliminar",
    Cancel: "Cancelar",
    Edit: "Editar",
    Copy: "Copiar",
    Paste: "Pegar",
    Proceed: "Continuar",
    Save: "Guardar",
    Back: "Atrás",
    Next: "Siguiente",
    Confirm: "Confirmar",
    Close: "Cerrar",
    Exit: "Salir",
    All: "Todo",
    Clear: "Limpiar",
    Yes: "Sí",
    No: "No",
    Template: "Plantilla",
    AddEquipment: "Agregar equipo",
    DownloadReport: "Descargar informe",
    MultiInput: "Entrada multipunto",
    AddBaseline: "Agregar línea base",
    Estimate: "Estimar",
    Calculate: "Calcular",
    ViewDetail: "Ver detalle",
    CollapseDetail: "Colapsar detalle",
    Generate: "Generar",
    Input: "Ingresar",
    Reconfigure: "Reconfigurar",
    Optimize: "Optimizar",
    CurrentYear: "Año actual",
    LastYear: "Año anterior",
    NextYear: "Próximo año",
    Last12Months: "Últimos 12 meses",
    Next12Months: "Próximos 12 meses",
    selectClearAll: "Seleccionar / Borrar todo",
    View: "Ver"
  },

  label: {
    ProjectName: "Nombre del proyecto",
    Multiple: "Múltiple",
    BuildVertical: "Tipo de edificio",
    DataCollectionMont: "Mes de recolección de datos",
    CurrencyLabel: "Moneda",
    TemperatureUnit: "Unidad de temperatura",
    Unit: "Unidad",
    Time: "Tiempo",
    Hour: "Hora",
    Hours: "Horas",
    Day: "Día",
    Days: "Días",
    Month: "Mes",
    Months: "Meses",
    Year: "Año",
    Years: "Años",

    ChillerType: "Tipo de enfriadora",
    PumpingConfiguration: "Configuración de bombeo",
    Primary: "primario",

    RatedPower: "Potencia nominal",
    RatedInputPower: "Potencia de entrada nominal",
    RatedCoolingCapacity: "Capacidad nominal de enfriamiento",
    Frequency: "Frecuencia",
    MaxHz: "Frecuencia máx.",
    MinHz: "Frecuencia mín.",
    RatedFrequency: "Frecuencia nominal",
    MaxFrequency: "Límite superior de frecuencia de operación",
    MinFrequency: "Límite inferior de frecuencia de operación",
    RatedHeatRejectionCapacity: "Capacidad nominal de rechazo de calor",

    VFD: "VFD",
    VariableFrequencyDrive: "Variador de frecuencia",

    AssetLabels: "Etiquetas de activo",
    UnitNumber: "Número de unidades (#)",
    PumpType: "Tipo de bomba",
    DateCommissioned: "Fecha de puesta en marcha",
    Degradation: "Factor de degradación",
    Brand: "Marca",
    Model: "Modelo",
    Remarks: "Comentarios",

    RatedInputPower_100: "Potencia de entrada nominal",
    RatedInputPower_100_ct: "Potencia de entrada nominal por torre de enfriamiento",

    RatedCoolingCapacity_100: "Capacidad nominal de enfriamiento",
    RatedHeatRejectionCapacity_100: "Capacidad nominal de rechazo de calor",

    DesignCondenserWaterEnteringTemp: "Temp. de entrada del agua de condensación (diseño)",
    TotalCellPerCoolingTower: "Número de celdas por torre de enfriamiento",
    ActualCondenserWaterEnteringTemp: "Temp. de entrada del agua de condensación (real)",
    TotalCellPerDryCooler: "Número de celdas por dry cooler",
    DryCoolerType: "Tipo de dry cooler",
    RatedCapacity: "Capacidad nominal",
    EnergyType: "Energía de entrada",

    BaselineName: "Nombre de la línea base",
    ApplicableMonths: "Meses aplicables",

    DataTable: "Tabla de datos",
    ChartView: "Vista de gráfico",
    CoolingLoad: "Carga de enfriamiento",
    Total: "Total",

    Observation: "Observación",
    Photo: "Foto",
    Maximum6: "Máximo 6",

    ChillerConfiguration: "Configuración de enfriadoras",
    BoilerConfiguration: "Configuración de caldera",
    CoolingSystemConfiguration: "Configuración del sistema de enfriamiento",

    MaxHeatingCapacity: "Capacidad máx. de calefacción (mes más frío)",
    EffectiveCapacity: "Capacidad efectiva (mes más frío)",
    BoilerEfficiency: "Eficiencia de caldera",
    hotWaterTemp: "Temperatura requerida para ACS",

    EnergyCarbonIntensity: "Intensidad de carbono de la energía",
    FuelCalorificValue: "Poder calorífico del combustible (CV)",

    ZeroHeatingOAT: "Temperatura de inicio de calefacción",
    MaxHeatingOAT: "Temperatura exterior a calefacción máxima",
    DesiredHotWaterTemp: "Temperatura deseada de ACS",
    BoilerUtilizationColdestTemp: "Utilización de caldera en el mes más frío",
    ColdestWater: "Temperatura más baja del agua entrante",

    WaterDemandPerDay: "Demanda media de agua por persona",
    UserNumber: "Número de ocupantes",
    liters: "litros",

    ChillerModel: "Modelo de enfriadora",
    RefChillerModel: "Modelo de referencia",
    WeatherProfile: "Perfil meteorológico",
    EstimatePath: "Ruta de estimación",
    AvailableData: "Datos disponibles",
    CondenserWaterTempProfile: "Perfil de temperature del agua de condensación",

    DesignCondenserSupplyTemp: "Temp. de impulsión del agua de condensación (diseño)",
    DesignCondenserAirSupplyTemp: "Diseño temperatura de suministro de aire del condensador",
    DesignChilledWaterTemp: "Temp. de impulsión de agua helada (diseño)",
    OutDoorDryBulbTemp: "Temp. exterior de bulbo seco",
    ChilledWaterSupplyTemp: "Temp. de impulsión de agua helada",
    TowerApproachTemp: "Approach de torre de enfriamiento",
    ActualCondenserSupplyTemp: "Temp. de impulsión del agua de condensación real",
    ActualCondenserAirSupplyTemp: "Temp. de suministro de aire del condensador real",
    ActualChilledWaterSupplyTemp: "Temp. de impulsión de agua helada real",
    MinCondenserWaterSupplyTemp: "Temp. mínima del agua de alimentación del condensador",
    DesignSourceWaterTemp: "Temperatura de impulsión del agua de fuente en condiciones de diseño",
    DesignSourceAirTemp: "Temperatura del aire de fuente en condiciones de diseño",
    DesignHotWaterSupplyTemp: "Temperatura de impulsión del agua caliente en condiciones de diseño",

    ChillerRunningNumber: "Número de enfriadoras en operación",
    CoolingCapacityRange: "Rango de capacidad",
    AllRightsReserved: "Todos los derechos reservados.",

    From: "Desde",
    To: "Hasta",

    Cluster: "Clúster",
    ClusterNum: "Número de clústeres",
    ClusterName: "Nombre del clúster",
    WeekPeriod: "Período semanal",
    AssociationMethod: "Método de asociación",

    MaxCoolingLoadBaseline: "Carga máx. en línea base",
    MaxCoolingLoad: "Carga máxima",
    AssociatedChiller: "Enfriadora asociada",
    MaxRunningNumber: "Número máx. en operación",
    Chiller: "Enfriadora",
    AssociatedHeatPump: "Bomba de calor asociada",

    RetrofitPreferences: "Preferencias de retrofit",

    CAPEX: "CAPEX (Precio del proyecto, instalación incluida)",
    OverallProjectPrice: "Precio total del proyecto",
    USFXRate: "Tipo de cambio USD",

    Option: "Opción",
    Solution: "Solución",

    GeneralInfo: "Información general",
    TechSpec: "Especificación técnica",
    PerformanceConditions: "Condiciones de rendimiento",
    EcatPerformanceInput: "Entrada de rendimiento e-CAT",
    Capacity: "Capacidad",
    CoolingCapacity: "Capacidad frigorífica",
    SerialNumber: "Número de serie",
    ElectricalLoad: "Carga eléctrica",

    Category: "Categoría",
    EfficiencyImprovement: "Mejora de eficiencia",
    CostSavingsPerYear: "Ahorro anual de costos",
    ROI: "Retorno de inversión",
    PaybackPeriod: "Período de recuperación descontado",
    SimplePayback: "Período de retorno simple",

    Estimated: "Estimado",
    Actual: "Real",

    Like: "Me gusta",
    Dislike: "No me gusta",

    OptionDetails: "Detalles de la opción",
    TotalEnergySavings: "Ahorro anual total de energía",
    RetrofitCost: "Costo de retrofit",
    ExpectedYears: "Período del ciclo de vida del activo",
    NPV: "Valor presente neto",

    ProjectIntroduction: "Introducción del proyecto",
    Assumptions: "Supuestos",
    AssumptionsConsider: "Supuestos considerados para el análisis",
    AssumptionsAnalysis: "Supuestos para el análisis",

    ChillerPlant: "Planta de enfriadoras",
    Configuration: "Configuración",
    PeakBuildingLoad: "Carga máxima del edificio",
    OAT: "Temperatura exterior (OAT)",
    EnergyConservationMeasures: "Medidas de ahorro de energía (ECM)",

    DesignFlowRate: "Caudal de diseño",
    RatedDesignFlowRate: "Caudal nominal (diseño)",
    DesignPressureHead: "Altura manométrica de diseño",
    PressureHead: "Altura manométrica",
    VFDFitted: "VFD instalado",

    DesignConditions: "Condiciones de diseño",
    ProjectSettings: "Configuración del proyecto",

    Tariff: "Tarifa",
    EnergyTariff: "Tarifa energética",
    MonthlyTariff: "Tarifa mensual",
    OperatingPeriod: "Período de operación",
    RunningMonths: "Meses de operación",

    Recommendation: "Recomendación",
    Benefit: "Beneficio",

    MonthlyRunningDays: "Días de operación ({type})",
    BaselineMonth: "Mes de línea base",
    EstimatedMonth: "Mes estimado",
    EstimatedPower: "Potencia estimada",
    ElectricityCarbonIntensity: "Intensidad de carbono de la electricidad",
    PlantEfficiency: "Eficiencia de planta",
    EfficienctyUnit: "Unidad de eficiencia",

    Type: "Tipo",
    SellingPricePrtUnit: "Precio de venta por unidad",
    ApplicableChiller: "Enfriadora aplicable",
    NoOfFansCT: "N.º de ventiladores / torre",

    Load: "Carga",
    Power: "Potencia",
    InputPower: "Potencia de entrada",

    TotalEnergyImprovement: "Mejora energética total",
    EquipmentStatus: "Estado del equipo",

    SetRecommended: "Marcar como recomendado",
    CancelRecommendation: "Cancelar recomendación",

    Optional: "Opcional",

    RetrofitCostConfiguration: "Configuración de costos de retrofit",
    PaybackPeriodSummaryNPV: "Resumen de payback y NPV",

    EquipmentDetailsProposed: "Detalles del equipo propuesto",
    GenerateECMReport: "Generar informe ECM",

    PeakMaxCoolingLoad: "Carga máx. en punta",
    OffPeakMaxCoolingLoad: "Carga máx. fuera de punta",

    ProposedCoolingCapacity: "Capacidad de enfriamiento propuesta",

    ChillerPlantTotal: "Total de planta",

    EnergySavingsPerYear: "Ahorro anual de energía",

    CapitalAssetRetrofitInvestmentCost: "Inversión CAPEX de retrofit",
    EstimatedProjectValue: "Valor estimado del proyecto",
    ActualProjectValue: "Valor real del proyecto",

    ProjectDetails: "Detalles del proyecto",

    ElectricalDB: "Tablero eléctrico",
    PlantControlSys: "Sistema de control",

    QuickSelect: "Selección rápida",
    ClusterMonth: "Meses del clúster",

    MonthlyCoolingLoad: "Carga mensual",
    MonthlyPower: "Potencia mensual",

    Default: "Predeterminado",
    ReconfigureSolution: "Reconfigurar solución",
    ReconfiguredSolution: "Solución reconfigurada",

    SingleChilledWaterTemp: "Temperatura única de agua helada",
    ECatPerformanceData: "Datos de rendimiento eCAT",
    CopyInputECATPerformance: "Copiar entrada de eCAT",

    CopyFrom: "Copiar desde",
    PasteInto: "Pegar en",

    PredictedUtilization: "Utilización predicha",
    UserConfirmedUtilization: "Utilización confirmada",

    ProjectObjective: "Objetivo del proyecto",
    ChillerEfficiency: "Eficiencia de enfriadora",
    ChillerPlantEfficiency: "Eficiencia de planta",
    HeatingEfficiency: "Eficiencia de calefacción",
    HeatingPlantEfficiency: "Eficiencia del sistema de calefacción",
    ChillerHeatingEfficiency: "Eficiencia de enfriadora y calefacción",
    ChillerRetrofit: "Reforma de enfriadora",
    ChillerPlantRetrofit: "Reforma de planta de enfriadoras",
    HeatingElectricRetrofit: "Rénovation de chaudière vers pompe à chaleur",
    HeatPumpRetrofit: "Reforma de bomba de calor",
    IntegratedRetrofit: "Reforma integrada de la planta de enfriamiento y calefacción",

    ManualInput: "Entrada manual",
    AutoSoon: "Próximamente automático",

    AvailableDesignTemp: "Temperatura de diseño disponible",
    ChillerSelection: "Selección de enfriadora",
    NewChillerSeries: "Nueva serie de enfriadoras",
    ECATLibraryType: "Tipo de biblioteca E-CAT",
    PerformanceTable: "Tabla de rendimiento",
    ChillerName: "Nombre de la enfriadora",
    StandardECAT: "eCAT estándar",
    EstimatedECAT: "eCAT estimado",
    CustomizedECAT: "eCAT personalizado",
    CustomCapacity: "Capacidad personalizada",

    OperatingDayType: "Tipo de día operativo",
    MonthlyOperatingDays: "Días operativos mensuales",
    OperatingSiteChiller: "Enfriadora operativa en sitio",
    ProxyChillerModel: "Modelo de enfriadora de referencia",
    ManufacturingRegion: "Región de fabricación",
    CompressorType: "Tipo de compresor",
    BearingType: "Tipo de rodamiento",
    VFDType: "Tipo de VFD",
    AvailableProxyModels: "Modelos de referencia disponibles",
    NominalCapacity: "Capacidad nominal",
    PointsCalibration_4: "Calibración de 4 puntos",
    PartLoadCalibration_note: "Para la calibración a carga parcial solo se admiten datos en condiciones de diseño de fábrica.",

    HourlyChillerOperation: "Operación horaria de la enfriadora",
    OperatingChillerCount: "Número de enfriadoras en operación",
    LoadRatio: "Relación de carga",
    CalculatedOperatingLoad: "Carga operativa calculada",

    NewChillerType: "Tipo de nueva enfriadora",

    ProposedEfficiency: "Eficiencia propuesta",
    RetrofitConfiguration: "Configuración de retrofit",
    ROI_NPVSummary: "Resumen de ROI y NPV",
    AssumptionOfferings: "Supuestos y ofertas",

    ProposedRunningNumber: "Número propuesto de equipos en operación",

    ProposedSummary: "Resumen propuesto",
    BaselineEfficiency: "Eficiencia de línea base",
    AnnualizedAverageROI: "ROI annual medio basado en VAN",

    SelectProposedScenarios: "Seleccionar escenarios propuestos",
    BaselineHourlyCoolingLoad: "Carga de enfriamiento horaria de referencia",

    ProxyChillerFilter: "Filtrar enfriadora de referencia",

    ChillerEfficiency_100: "Eficiencia del enfriador al 100 % de carga",
    DegradedEfficiency_100: "Eficiencia degradada al 100 % de carga",

    CommercialInput: "Datos comerciales",

    SiteSettings: "Configuración del sitio",
    ExistingBoilerSystem: "Sistema de caldera existente",
    HeatingApplication: "Aplicación de calefacción",

    PerformanceModel: "Modelo de rendimiento",
    HeatingCapacityPerUnit: "Capacidad de calefacción nominal por unidad",
    BaselineSetup: "Configuración de referencia",
    OperatingMonths: "Meses de operación",
    OperatingBoiler: "Caldera en operación",
    BoilerNumAtColdest: "Número de calderas en operación a la temperatura más baja",
    singlePriceNote: "Se utiliza para estimar el CAPEX del proyecto (instalación incluida).",

    BoilerDetails: "Detalles del sistema de caldera",
    HeatPumpCfg: "Configuración de la bomba de calor",
    HeatPumpSourceType: "Tipo de fuente de la bomba de calor",
    HotWaterSupplyTemp: "Temperatura del suministro de agua caliente",
    ActualHWSTemp: "Temperatura real del suministro de agua caliente",
    SingleHWSTemp: "Temperatura individual del suministro de agua caliente",
    WaterSourceTemp: "Temperatura de la fuente de agua",
    GroundLoop: "Circuito geotérmico",
    HeatingCapacity: "Capacidad de calefacción",
    RatedHeatingCapacity: "Capacidad de calefacción nominal",
    HeatPumpSelection: "Selección de la bomba de calor",
    HeatPumpName: "Nombre de la bomba de calor",
    HeatPumpModel: "Modelo de la bomba de calor",
    ModelNumber: "Número de modelo",
    AirSourceTemp: "Temperatura de la fuente de aire",
    DesignAirSourceTemp: "Temperatura de diseño de la fuente de aire",
    DesignEWSTemp: "Temperatura de diseño del suministro de agua del evaporador",
    RatedCOP_100: "COP nominal al 100%",

    ProposedHeatPumpCOP: "COP propuesto de la bomba de calor",
    MaxHeatingLoad: "Carga máxima de calefacción",
    ProposedHeatPumpCapacity: "Capacidad propuesta de la bomba de calor por unidad",
    CostAssumptionInputs: "Entradas de costos y supuestos",
    ExistingAnnualCost: "Costo anual existente",
    ProposedAnnualCost: "Costo anual propuesto",
    Escalation: "Escalación"
  },

  option: {
    New: "Nuevo",
    Existing: "Existente",
    Remove: "Eliminar",

    LARGE_OFFICE: "Oficina grande",
    MEDIUM_OFFICE: "Oficina mediana",
    SMALL_OFFICE: "Oficina pequeña",
    RESTAURANT: "Restaurante",
    HOSPITAL: "Hospital",
    HOTEL: "Hotel",
    MALL: "Centro comercial",
    SCHOOL: "Escuela",
    EDUCATIONAL_INSTITUTIONS: "Instituciones educativas",
    RESIDENTIAL: "Residencial",
    OTHERS: "Otros",

    Month: "Mes",
    Jan: "Ene",
    Feb: "Feb",
    Mar: "Mar",
    Apr: "Abr",
    May: "May",
    Jun: "Jun",
    Jul: "Jul",
    Aug: "Ago",
    Sep: "Sep",
    Oct: "Oct",
    Nov: "Nov",
    Dec: "Dic",

    plant: "Planta de enfriadoras",
    chiller: "Enfriadora",
    pump: "Bomba",
    coolingTower: "Torre de enfriamiento",
    piping: "Tuberías",
    dryCooler: "Enfriador seco",
    controlSys: "Sistema de control",
    boiler: "Caldera",
    heatPump: "Bomba de calor",
    other: "Otros",

    WaterCooled: "Enfriado por agua",
    AirCooled: "Enfriado por aire",
    WaterCooled_AirCooled: "Enfriado por agua y aire",

    chwp: "Bomba de agua helada",
    chwpPrimary: "Bomba de agua helada - primaria",
    chwpSecondary: "Bomba de agua helada - secundaria",
    PrimaryPump: "Bomba primaria",
    SecondaryPump: "Bomba secundaria",
    cwp: "Bomba de agua de condensación",
    CondenserWater: "Agua de condensación",
    ChilledWaterPrimary: "Sistema primario de agua helada",
    ChilledWaterPrimarySecondary: "Sistema primario-secundario de agua helada",
    CondenserWaterSys: "Sistema de agua de condensación",
    CommonHeader: "Colector común",
    Dedicated_1_1: "Dedicado 1-1",

    wcCentri: "Agua - centrífuga",
    wcScrew: "Agua - tornillo",
    wcRecip: "Agua - alternativo",
    wcScroll: "Agua - scroll",
    acScrew: "Aire - tornillo",
    acScroll: "Aire - scroll",
    acRecip: "Aire - alternativo",

    Centrifugal: "Centrífugo",
    Screw: "Tornillo",
    Scroll: "Desplazamiento",
    Reciprocating: "Reciprocar",
    Rotary: "Rotativo",

    Degradation_25: "0,25% por año",
    Degradation_50: "0,50% por año",
    Degradation_75: "0,75% por año",
    Degradation_100: "1,00% por año",

    GoodCondition: "Buen estado",
    AverageCondition: "Estado medio",
    BelowAverageCondition: "Por debajo de la media",
    BadCondition: "Mal estado",

    SpaceCooling: "Enfriamiento de espacios",
    SpaceHeating: "Calefacción de espacios",
    DomesticHotWater: "Agua caliente sanitaria",
    SHandDHW: "Calefacción de espacios y agua caliente sanitaria",

    GasFuel: "Gas",
    LiquidFuel: "Combustible líquido",
    ElectricalEnergy: "Energía eléctrica",

    DryBulbTemp: "Temp. media bulbo seco",
    WetBulbTemp: "Temp. media bulbo húmedo",
    WaterTemp: "Temperatura del agua",

    MaxDryBulbTemp: "Temp. máx. bulbo seco",
    MinDryBulbTemp: "Temp. mín. bulbo seco",
    AvgDryBulbTemp: "Temp. med. bulbo seco",
    MaxWetBulbTemp: "Temp. máx. bulbo húmedo",
    MinWetBulbTemp: "Temp. mín. bulbo húmedo",
    AvgWetBulbTemp: "Temp. med. bulbo húmedo",

    PeakWaterTemp: "Temp. agua (punta)",
    OffPeakWaterTemp: "Temp. agua (valle)",
    AvgTemp: "Temp. promedio",

    ColdWaterTemp: "Temp. agua entrante",

    CondenserWaterSupplyTemp: "Temp. de impulsión del condensador",
    MeanCondenserWaterSupplyTemp: "Temp. prom. impulsión condensador",
    MeanMaxCWSTemp: "Temp. máx. prom. impulsión condensador",
    MeanAvgCWSTemp: "Temp. prom. impulsión condensador",

    CondenserAirSupplyTemp: "Temp. de aire al condensador",
    MeanCondenserAirSupplyTemp: "Temp. prom. aire condensador",
    MeanMaxCASTemp: "Temp. máx. prom. aire condensador",
    MeanAvgCASTemp: "Temp. prom. aire condensador",

    PathA: "Basado en carga de enfriamiento",
    PathB: "Basado en consumo de energía",
    Method1: "Perfil horario 1 mes",
    Method3: "Perfil horario 12 meses",

    HeatingPathA: "Solo carga de caldera",
    HeatingPathB: "Carga de caldera + datos de energía",

    Off: "Apagado",
    Peak: "Punta",
    OffPeak: "Valle",
    AllPeak: "Todo punta",
    PeakPeriod: "Período punta",
    OffPeakPeriod: "Período valle",
    WeekdayPeak: "Laborable punta",
    WeekdayOffPeak: "Laborable valle",
    WeekendPeak: "Fin de semana punta",
    WeekendOffPeak: "Fin de semana valle",

    AllCity: "Todas las ciudades",
    MegaCity: "Megaciudad",
    NonMegaCity: "No megaciudad",

    Win: "Ganado",
    PipeLine: "En seguimiento",
    TotalPipeline: "Pipeline total",
    ActualOrder: "Pedido real",
    ExpectedOrder: "Pedido esperado",

    All: "Todo",
    Values: "Valores",
    Projects: "Proyectos",
    Count: "Cuenta",
    WinProbability: "Probabilidad de ganar",

    SingleCluster: "Clúster único",
    MultipleCLuster: "Clústeres múltiples",

    HighestEfficiencyImprovement: "Mayor mejora de eficiencia",
    LowestInvestment: "Menor inversión",
    ShortestPaybackPeriod: "Menor payback",

    Max: "Máx",
    Min: "Mín",
    Avg: "Prom",

    StepMonthlyCoolingLoad: "Carga mensual",
    StepEstimateCoolingLoad: "Estimar carga",
    StepEstimatePower: "Estimar potencia de enfriadora",
    StepEstimatePowerLoad: "Estimar potencia de enfriadora",
    EstimateChillerCount: "Número estimado de enfriadoras",

    OperatingCalendar: "Calendario operativo",
    OperatingHours: "Horas de operación",
    OperatingLoad: "Carga operativa",
    ReferChiller: "Enfriadora de referencia",
    MonthlyChillerCount: "Número mensual de enfriadoras",

    RunningHours: "Horas de operación",
    EnergyConsumption: "Consumo de energía",
    ChillerEnergyConsumption: "Consumo energético del enfriado",

    AuxiliaryPower: "Potencia auxiliar",
    PlantEquipment: "Equipos de planta",
    ChillerPower: "Potencia de enfriadora",
    CHWPPower: "Potencia bomba agua helada",
    CWPPower: "Potencia bomba agua de condensación",
    CTPower: "Potencia torre de enfriamiento",

    WeightedAvgEfficiency: "Eficiencia promedio ponderada",
    WeightedAvgCoolingLoad: "Carga promedio ponderada",
    WeightAvgPower: "Potencia promedio ponderada",
    RunningHrsPerDay: "Horas de operación por día",
    ActualWeightedAveragePower: "Potencia media ponderada real",

    AnnualCost: "Costo anual",
    AnnualEscalation: "Escalamiento anual",
    IncentiveRebate: "Incentivos y reembolsos",

    ProposeConfig: "Configuración propuesta",

    Weekday: "Laborable",
    Weekend: "Fin de semana",
    WholeWeek: "Semana completa",

    Automatic: "Automático",
    Manual: "Manual",
    Reconfigured: "Reconfigurado",
    AlgorithmSelectsConfig: "El algoritmo selecciona la configuración",
    UserSelectsConfig: "El usuario selecciona la configuración",

    ManualCluster: "Clúster manual",
    DigitalECAT: "eCAT digital",

    BoilerUtilization: "Utilización de caldera",
    HeatingLoad: "Carga de calefacción",
    MonthlyHeatingLoad: "Carga mensual de calefacción",
    EffectiveMonthly: "Energía mensual efectiva",
    EnergyCharges: "Costos de energía",
    CO2Emissions: "Emisiones de CO₂",
    GasFuelConsumption: "Consumo de combustible gaseoso",
    LiquidFuelConsumption: "Consumo de combustible líquido",
    ElectricalEnergyConsumption: "Consumo de energía eléctrica",
    GasFuelCharges: "Cargos por combustible gaseoso",
    LiquidFuelCharges: "Cargos por combustible líquido",
    ElectricalEnergyCharges: "Cargos por energía eléctrica",

    Standard: "Estándar",
    Ceramic: "Cerámico",
    Magnetic: "Magnético",
    VFD: "Variador de frecuencia",
    NonVFD: "Sin variador de frecuencia",
    ClusterMonths: "Meses agrupados",

    Chiller: "Enfriadora",
    HeatPump: "Bomba de calor",
    WaterSource: "De fuente de agua",
    AirSource: "De fuente de aire",

    ConstantEfficiency: "Eficiencia constante",
    UserDefinedCurve: "Curva definida por el usuario",
    BoilerOperation: "Operación de la caldera",
    MonthlyEnergyConsumption: "Consumo mensual de energía",
    AvgHeatingLoad: "Carga de calefacción promedio ponderada",
    MonthlyBoilerCount: "Cantidad mensual de calderas",
    BoilerEnergyConsumption: "Consumo de energía de la caldera",
    EstimateBoilerCount: "Cantidad estimada de calderas",
    EstimateHeatingLoad: "Carga de calefacción estimada",
    EstimateEnergyConsumption: "Estimar el consumo de energía",

    ECatLib: "Biblioteca e-CAT",
    OwnLib: "Biblioteca propia"
  },

  msg: {
    imageOnly: "Solo se permiten archivos de imagen",
    comingSoon: "Próximamente.",
    Success: "Éxito",
    FailedRetry: "¡Falló! Por favor, inténtelo de nuevo",
    DeleteEquip: "Eliminar equipo",
    DeleteWarning: "¿Confirma que desea eliminar: ",
    DeleteBaseline: "Eliminar línea base",
    Warning: "Advertencia",
    UnsavedWarning: "Los cambios no guardados se perderán si sale de la página actual.",
    SaveBeforeProceeding: "¿Desea guardar sus cambios antes de continuar?",
    NoOptionsSelected: "No se seleccionó ninguna opción",
    AlreadyExists: "Ya existe",
    Saving: "Guardando...",
    Generating: "Generando...",
    Loading: "Cargando...",
    DeletingFiles: "Eliminando archivos...",
    CompressingFiles: "Comprimiendo archivos...",
    UnsupportedImageTypeTitle: "Archivos no compatibles omitidos",
    UnsupportedImageTypesDiscarded: "Tipos de archivo omitidos",
    UploadingFiles: "Subiendo archivos...",
    NetworkError: "Anomalía de red, operación fallida",
    NetworkLimit: "Anomalía de red, función limitada",
    Over24HoursTips: "Tiempo total superior a 24 horas",
    Over24HoursToast: "El tiempo total punta/valle no debe superar 24 horas",
    CityChanged: "La ciudad ha sido cambiada de {curtCity} a {newCity}.",
    OverrideWeatherData: "<br>¿Desea sobrescribir el perfil meteorológico existente usando la OAT de la ciudad recién seleccionada?",
    ProjectNameIsEmpty: "El nombre del proyecto no puede estar vacío",
    CityIsEmpty: "La ciudad no puede estar vacía",
    SelectReferModel: "Seleccione un modelo de referencia",
    InputDataIntoReferenceChiller: "Ingrese los datos anteriores en la enfriadora de referencia",
    PeriodCanNotAllOff: "El período no puede estar completamente apagado",
    CanNotBlank: "No puede estar vacío",
    CanNotBlankZero: "No puede estar vacío ni ser 0",
    CanNotAllBlank: "No puede estar todo vacío",
    CanNotAllBlankZero: "No puede estar todo vacío ni todo en 0",
    NetworkTimeout: "¡Tiempo de red agotado! Por favor intente de nuevo",
    RequestError: "Error de solicitud",
    LoginExpired: "Sesión expirada",
    AccessDenied: "Acceso denegado",
    ResourceNotExist: "El recurso solicitado no existe",
    ServerError: "Error de servicio",
    GatewayError: "Error de pasarela",
    ServiceUnavailable: "Servicio no disponible",
    UserNotExist: "El usuario no existe",
    WrongPassword: "Contraseña incorrecta",
    NotActivate: "Cuenta no activada",
    DeleteCluster: "Eliminar clúster",
    Estimating: "Estimando...",
    Analyzing: "Analizando...",
    Calculating: "Calculando...",
    UnsavedAfterEstimate: "Los datos no guardados ingresados después de la última estimación se perderán si abandona esta página.",
    DiscountRateTips: "La tasa de descuento determina los retornos esperados; si no se proporciona, se aplica la inflación.",
    CalculateROINotice: "Haga clic en “1. Ingresar” para completar el costo de retrofit y luego en “Calcular ROI”.",
    ConfirmFxRate: "Confirme el tipo de cambio USD",
    SetRecommended: "Establecer {name} como recomendado",
    SelectCardPasteInto: "Seleccione la tarjeta en la que desea pegar.",
    Copied: "Copiado al portapapeles",
    Pasted: "Pegado",
    OverwriteOption: "Regenerar sobrescribirá todos los datos de solución existentes y eliminará el informe generado.",
    OverwriteOptionAll: "Ha configurado una solución optimizada. <br/>Regenerar sobrescribirá todos los datos de solución existentes y eliminará el informe generado.",
    RefreshRequired: "Actualización requerida",
    ReAnalysisPre:
      "Para generar o actualizar la vista previa de la Baseline, actualice primero el análisis de carga de refrigeración y potencia en la Baseline mensual y, a continuación, actualice manualmente la vista previa de la Baseline.",
    ReAnalysisHeating:
      "Para generar o actualizar la Vista previa de referencia, actualice primero el Análisis de carga de calefacción y energía en la línea base mensual, luego actualice manualmente la Vista previa de referencia.",

    PleaseSelectObjective: "Selecciona un objetivo",
    HeatingOnlySupportsPre: "El módulo de eficiencia de calefacción actualmente solo admite pre‑retrofit",
    CompleteBaselineConfigFirst: "Complete primero la configuración de la línea base en pre‑retrofit.",
    CompleteBaselineAnalysisFirst: "Complete primero el análisis de la línea base en pre‑retrofit.",

    AcceptOneUtilization: "¿Aceptar Utilización prevista como Utilización confirmada por el usuario?",
    AcceptAllUtilization: "¿Aceptar toda la Utilización prevista como Utilización confirmada por el usuario?",
    NoReportGenerate: "Sin informe, introduzca el proyecto para generarlo.",

    DependencyHint: "Indicación de dependencia:",
    DryBulbDependencyCooling: "La temperatura de bulo seco se utiliza para estimar el perfil de carga de refrigeración.",
    WeatherDependencyCooling:
      "Para los enfriadores refrigerados por agua, la temperatura de suministro del agua del condensador se utiliza para estimar el consumo eléctrico del enfriador. Para los enfriadores refrigerados por aire, se utiliza la temperatura de bulbo seco.",

    DryBulbDependencyHeating:
      "La temperatura de bulbo seco se utiliza para estimar el perfil de carga de calefacción de espacios, mientras que la temperatura de entrada del agua fría se utiliza para estimar el perfil de carga de agua caliente sanitaria.",
    WeatherDependencyHeating: "Los parámetros meteorológicos mostrados arriba dependen de la aplicación de calefacción seleccionada.",

    CalibrationTitle: "Datos incompletos de calibración de 4 puntos",
    CalibrationNote:
      "Los datos de calibración de 4 puntos del enfriador de referencia están incompletos. Introduzca los valores de los cuatro puntos de carga (25 %, 50 %, 75 % y 100 %) o desactive la calibración de 4 puntos para continuar.",
    CalibrationBack: "Volver al enfriador de referencia",

    SelectReportingFocus: "Seleccionar el enfoque del informe para el cliente",
    ROILedSummary: "Resumen orientado al ROI",
    EfficiencyLedSummary: "Resumen orientado a la mejora de la eficiencia",
    ROILedNote: "Usar cuando la inversión, el ahorro y los resultados de la amortización sean suficientes para justificar el proyecto.",
    EfficiencyLedNote: "Usar cuando la mejora de la eficiencia sea la justificación principal, independientemente de lo atractivo que sea el periodo de amortización.",
    ROILedNote_C: "Utilícelo cuando se disponga de datos de inversión, ahorro y período de recuperación.",
    EfficiencyLedNote_C: "Utilícelo cuando la decisión se base principalmente en la mejora de la eficiencia energética o cuando los datos de ROI no estén disponibles o no sean relevantes.",

    ImgIgnoredWhenOffline: "Las operaciones de imagen se ignorarán cuando esté sin conexión"
  },

  placeholder: {
    PleaseInput: "Por favor ingrese",
    SearchHere: "Buscar aquí",
    PleaseSelect: "Por favor seleccione",
    SearchFilter: "Buscar y filtrar",
    NotAvailable: "No disponible",
    NoDataExist: "No hay datos",
    NoDataAvailable: "No hay datos disponibles",
    NoChillerExist: "No existen datos de enfriadoras",
    NoBaselineExist: "No existen datos de línea base",
    ClusterAutomaticallyMatches: "Asocia automáticamente todos los períodos de operación",
    NoClusterExist: "No hay meses de clúster, configure primero los meses",
    SelectTempCluster: "Por favor seleccione la temperatura del clúster",
    PleaseSelectInputFormat: "Seleccione o ingrese, formato: ",
    SearchFormat: "Buscar aquí, formato: ",
    DigitalECatNotify: "Los datos eCAT digitales se están integrando. Use el clúster manual por ahora",

    AssumptionsPlaceholder:
      "Describa los supuestos para el análisis. Especifique las condiciones meteorológicas consideradas, el perfil mensual del equipo operativo y los datos de los clientes compartidos durante la entrevista. También puede utilizar el botón Plantilla para obtener la descripción estándar.",
    AssumptionsTemp:
      "Este análisis se basa en [datos de consumo energético de la enfriadora / datos de carga de enfriamiento], estimados a partir de entrevistas operativas. Estos datos se utilizan para estimar el desempeño mensual a carga parcial (part-load) de la enfriadora existente [Ingrese el modelo de enfriadora], correlacionándolo con los datos meteorológicos históricos locales del período correspondiente.\n\n\
(Opcional: usar si el consumo de la enfriadora se expresa como un porcentaje del consumo total del edificio)\n\
Contribución energética de la planta de enfriamiento:\n\
Se asume que el consumo energético de la planta de enfriadoras (chiller plant) equivale a [Ingrese el porcentaje, p. ej., 45 %] del consumo energético total del edificio.\n\n\
Se utilizaron los siguientes parámetros operativos, confirmados con el equipo del cliente:\n\
Horario de operación de las enfriadoras:\n\
[Número] enfriadora(s) operan de [Mes] a [Mes].\n\
[Número] enfriadora(s) operan de [Mes] a [Mes].",

    ObservationNote: "Conserve solo las opciones entre corchetes aplicables y verifique toda la información del sitio antes de guardar.",
    Observation_chiller:
      "La enfriadora existente muestra envejecimiento y menor eficiencia. En el sitio se observan [alarmas frecuentes / alto consumo / operación inestable / mayor mantenimiento], especialmente en [carga parcial / carga punta].",
    Recommendation_chiller:
      "Realizar una prueba de rendimiento y revisar consignas, refrigerante, superficies de intercambio y controles. Según los resultados, optimizar la operación o sustituir la unidad por una enfriadora eficiente de velocidad variable.",
    Benefit_chiller:
      "Los beneficios previstos incluyen menor consumo, mejor eficiencia a carga parcial, menos paradas imprevistas, menor coste de mantenimiento y suministro de agua fría más estable. Una sustitución eficiente también puede reducir emisiones y mejorar la fiabilidad a largo plazo.",
    Observation_pump:
      "La bomba de [agua fría / agua de condensación] funciona a [velocidad fija / un punto ineficiente]. El caudal parece excesivo a carga parcial y se observó [ruido / vibración / fuga / presión inestable].",
    Recommendation_pump:
      "Verificar punto de operación, caudal, altura, válvulas y equilibrado. Reajustar la bomba y el control. Cuando sea viable, instalar o activar un variador y ajustar la velocidad según la presión diferencial o la demanda.",
    Benefit_pump:
      "La medida puede reducir la energía de bombeo, el exceso de caudal y las pérdidas por estrangulación, mejorar el delta T y la estabilidad hidráulica, y reducir el desgaste. La operación según demanda puede disminuir el mantenimiento y mejorar la eficiencia global de la planta.",
    Observation_coolingTower:
      "La torre presenta [alto acercamiento / relleno sucio / distribución desigual / control deficiente de ventiladores / incrustaciones]. La temperatura del agua de condensación no se mantiene de forma eficiente.",
    Recommendation_coolingTower:
      "Inspeccionar y limpiar relleno, balsa, boquillas, filtros y superficies de intercambio. Revisar tratamiento de agua, flujo de aire y ventiladores. Optimizar etapas y usar variación de velocidad para mantener la temperatura requerida.",
    Benefit_coolingTower:
      "Un mejor rendimiento puede reducir la temperatura del agua dentro de límites seguros, disminuir la presión de condensación y el consumo de la enfriadora, estabilizar la planta y limitar incrustación o corrosión. El control de ventiladores también puede ahorrar energía y alargar la vida útil.",
    Observation_controlSys:
      "El sistema de control ofrece principalmente supervisión básica y no optimiza la secuencia de enfriadoras, bombas y torres. Las consignas y etapas son [fijas / manuales / no coordinadas con la carga].",
    Recommendation_controlSys:
      "Actualizar o reajustar el control de planta con secuenciación según demanda, reajuste de consignas, etapas, gestión de alarmas y seguimiento del rendimiento. Calibrar sensores clave de temperatura, presión, caudal y potencia.",
    Benefit_controlSys:
      "Un control coordinado puede mejorar la eficiencia global al operar enfriadoras, bombas y torres como un solo sistema. Puede reducir horas innecesarias, estabilizar temperaturas y caudales, mejorar la detección de fallos y apoyar el seguimiento continuo y la optimización energética.",
    Observation_dryCooler:
      "El enfriador seco presenta [baterías sucias / flujo de aire restringido / aletas dañadas / alta temperatura de salida / mal control]. Los ventiladores operan [a velocidad fija / de forma inestable] y el rechazo de calor parece insuficiente a [carga parcial / punta].",
    Recommendation_dryCooler:
      "Inspeccionar y limpiar las baterías, enderezar aletas y retirar obstrucciones de aire. Verificar caudal, giro de ventiladores, sensores y controles. Optimizar etapas o velocidad según la temperatura de salida y la demanda.",
    Benefit_dryCooler:
      "Un mejor rendimiento puede reducir la temperatura del fluido, mejorar el rechazo de calor y bajar el consumo de ventiladores y enfriadora. Un control optimizado reduce horas y ruido; el mantenimiento de baterías conserva capacidad, estabilidad y vida útil.",
    Observation_boiler:
      "La caldera existente proporciona [calefacción de espacios/ACS]. La caldera funciona con [tipo de combustible] y presenta [alto consumo de combustible/ciclos frecuentes/temperatura de impulsión elevada/ineficiencia de combustión/fugas]. Se observa un monitoreo o una optimización basada en la carga limitados.",
    Recommendation_boiler:
      "Evalúe la carga de calefacción, la temperatura de impulsión del agua, el horario de funcionamiento y los requisitos de las unidades terminales. Evalúe la idoneidad de la bomba de calor y determine si la caldera debe conservarse para el funcionamiento en punta o de respaldo.",
    Benefit_boiler:
      "La integración de una bomba de calor puede reducir el consumo de combustible, las emisiones de carbono y los costes operativos, manteniendo al mismo tiempo el rendimiento de calefacción requerido. Un ajuste de carga adecuado mejora la eficiencia estacional y puede reducir la dependencia de la combustión de combustibles fósiles. Conservar las calderas existentes solo para servicio de punta o de respaldo puede minimizar el riesgo de la modernización, apoyando a la vez los objetivos de descarbonización."
  },

  param: {
    hr: "Tiempo",
    period: "Período",
    chCount: "Número de enfriadoras en operación",
    maxLoad: "Carga nominal máxima",
    percent: "Carga de operación",
    capacity: "Carga total en operación",
    consumption: "Consumo de energía",
    existing: "Existente",
    proposed: "Propuesto",
    assumptions: "Supuestos",
    energy: "Energía",
    maintenance: "Mantenimiento",
    repair: "Reparación",
    other: "Otros",
    discountRate: "Tasa de descuento"
  },

  wizard: {
    navbar: {
      Wizard: "Asistente",
      MinimumInput: "Configuración rápida",
      GenerateDefaults: "Generar valores predeterminados iniciales",
      ReviewAssumptions: "Revisar supuestos",
      RunQuickCalculation: "Ejecutar cálculo rápido",
      ProposedSolution: "Resultados de la evaluación"
    },
    label: {
      ActualConditions: "Condiciones reales",
      MonthlyAverageTariff: "Tarifa media mensual",
      YearlyEnergyBill: "Factura anual de energía",
      ReviewSection: "Sección de revisión",
      CoolingApplication: "Tipo de aplicación de refrigeración",
      TemperatureSensitivityFactor: "Factor de sensibilidad a la temperatura"
    },
    option: {
      PROCESS_COOLING: "Refrigeración de procesos",
      DATA_CENTER: "Centro de datos",
      ComfortCooling: "Refrigeración de confort",
      MixedUse: "Uso mixto",
      ProcessDataCenter: "Procesos / Centro de datos",
      Custom: "Personalizado"
    },
    msg: {
      GeneratingDefaults: "Generando valores predeterminados...",
      RunningQuickCalculation: "Ejecutando el cálculo rápido...",
      DataOverwriteWarning: "Advertencia de sobrescritura de datos",
      PendingResultChangesWarning: "Ha realizado cambios en la página de revisión. Inicie la generación de nuevos resultados antes de continuar.",
      RegenerateDefaultsWarning: "Al volver a generar los valores predeterminados, se sobrescribirán permanentemente los datos actuales de los gráficos de la página de revisión. ¿Desea continuar?",
      PeriodCanNotAllOffEveryBaseline: "El período no puede estar completamente desactivado en cada línea base."
    }
  }
}



// WEBPACK FOOTER //
// ./src/locale/index/es.js